module.exports = __webpack_public_path__ + "img/G-extension.12dcadec.png";